module.exports = __webpack_public_path__ + "static/img/79.6b223732.png";